module.exports = __webpack_public_path__ + "assets/img/vti.5f9cd6d.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/vti.png
// module id = 17
// module chunks = 66